// LOG ENABLED
export var LOG_ENABLED = true;
export var API_ID_REQUEST_HEADER = "API_ID";

export const COUNTRY_CODE = "KZ";
export const API_ID = null

export const BASE_URL = window.location.hostname === 'localhost'
  ? window.location.protocol + '//' + window.location.hostname + ':9011'
  : window.location.protocol + '//' + window.location.hostname + '/api'